import { render } from "./CommercialDetailsModal.vue?vue&type=template&id=642a772f&scoped=true"
import script from "./CommercialDetailsModal.vue?vue&type=script&lang=js"
export * from "./CommercialDetailsModal.vue?vue&type=script&lang=js"

import "./CommercialDetailsModal.vue?vue&type=style&index=0&id=642a772f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642a772f"]])

export default __exports__